import Button, { ButtonProps } from '@material-ui/core/Button';
import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';
import React, { ReactElement } from 'react';

export interface LoadingButtonProps extends ButtonProps {
    loading?: boolean;
    elevation?: any;
    loaderProps?: {
        [key: string]: any;
        size: CircularProgressProps['size'];
        color: CircularProgressProps['color'];
    };
}

export const LoadingButton = (props: LoadingButtonProps): ReactElement => {
    const { loading, loaderProps, disabled, elevation, ...rest } = props;

    const { size, color, ...restLoader } = loaderProps || {};

    if (elevation === 0) {
        rest.disableElevation = true;
    }

    return (
        <Button role={'button'} disabled={disabled || loading} {...rest}>
            {loading ? (
                <span className={'loader'} style={{ marginRight: 5 }} {...(restLoader || {})}>
                    <CircularProgress color={color || 'primary'} size={size || 20} />
                </span>
            ) : null}
            {props.children}
        </Button>
    );
};

LoadingButton.displayName = 'LoadingButton';
